module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/firehose-2015-08-04.paginators.json
// module id = 404
// module chunks = 0